import { Deck } from "../models/deck";
import { Tree } from "../cards/forest/tree";
import { StreamBed } from "../cards/forest/streambed";
import { Cave } from "../cards/forest/cave";
export class Forest extends Deck {
}
Forest.displayName = "Forest";
Forest.artUrl = "./assets/decks/forest.jpg";
// @ts-ignore
Forest.initialCards = [Tree];
Forest.initialCardAddQueue = [Tree, Tree, StreamBed, Tree, Tree, StreamBed]; // Cave, Tree, StreamBed, Tree(and then just Caves all the way down?)
Forest.initialCardsAllowed = new Set([Tree]);
Forest.defaultCardAdd = Cave;
